module.exports = __webpack_public_path__ + "static/18invgde-7df7bc032297b25171233841158aeb9b.gif";